"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DiamondX: function() {
        return DiamondX;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const DiamondX = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2.00009 13.4143C1.21904 12.6332 1.21905 11.3669 2.00009 10.5858L6.29299 6.29293L10.586 1.99997C11.367 1.21892 12.6333 1.21892 13.4144 1.99997L22.0002 10.5858C22.7813 11.3669 22.7813 12.6332 22.0002 13.4143L13.4144 22.0001C12.6333 22.7812 11.367 22.7812 10.5859 22.0001L6.29299 17.7071L2.00009 13.4143ZM8.41431 17L12.0002 20.5859L15.5859 17.0001L12.0001 13.4143L8.41431 17ZM10.5859 12L7.00009 15.5858L3.41431 12L7.00009 8.41425L10.5859 12ZM13.4143 12L17.0002 15.5859L20.586 12L17.0002 8.41418L13.4143 12ZM15.5859 6.99997L12.0001 10.5858L8.41431 7.00004L12.0002 3.41418L15.5859 6.99997Z",
        fill: "currentColor"
    })
}), "DiamondX");
const _default = DiamondX;
